<mat-card *ngIf="reminderTypes" class="content-card">

  <mat-card-header fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
    <mat-card-title>
      <h5>{{caption}}</h5>
    </mat-card-title>
    <div fxFlex></div>
    <button mat-raised-button color="primary" (click)="addReminderType()">Add</button>
  </mat-card-header>

  <mat-card-content>

    <ng-container *ngIf="description">
      <div class="mb-1"> <small>{{description}}</small></div>
    </ng-container>

    <div *ngFor="let type of reminderTypes; let i = index" class="bordered-row">
      <app-push-notification-reminder-type
        [key]="i"
        [reminderType]="reminderType"
        [pushNotificationReminderType]="type"
        [pushNotificationReminderTypes]="reminderTypes"
        [pushNotificationTemplates]="pushNotificationTemplates"
        >
      </app-push-notification-reminder-type>
    </div>
  </mat-card-content>
</mat-card>
